// @flow
import * as React from 'react'

import Loader from '../../layout/component/loader'
import { fetchAction } from '../../../service/fetch'

import {
  type Request,
} from '../../../types'

type Props = {
  perform: Request;
  children: (args: {
    data: any;
    fetch: () => Promise<*>;
    isLoading: boolean;
  }) => React.Node;
  params?: Object;
  hideLoader?: boolean;
}

type State = {
  isLoading: boolean;
  data?: any;
  error?: string;
}

class DataGet extends React.Component<Props, State> {
  state = {
    isLoading: true,
    data: undefined,
    error: undefined,
  }

  componentDidMount() {
    this.fetch()
  }

  fetch = (dynamicParams: any = {}) => {
    const { perform, params } = this.props

    this.setState({ isLoading: true })
    return fetchAction(perform, {
      ...params,
      ...dynamicParams,
    })
      .then((response) => {
        this.setState({
          isLoading: false,
          data: response,
        })
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          error,
        })
      })
  }

  render() {
    const { children, hideLoader } = this.props
    const { data, isLoading } = this.state

    if (isLoading && !hideLoader) {
      return <Loader active />
    }

    return children({
      fetch: this.fetch,
      data,
      isLoading,
    })
  }
}

export default DataGet
